import { render } from "./newCenter.vue?vue&type=template&id=7f0b8fde&scoped=true"
import script from "./newCenter.vue?vue&type=script&lang=js"
export * from "./newCenter.vue?vue&type=script&lang=js"

import "./newCenter.vue?vue&type=style&index=0&id=7f0b8fde&scoped=true&lang=scss"

import exportComponent from "D:\\SelfCode\\ktpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f0b8fde"]])

export default __exports__